module.exports = __webpack_public_path__ + "img/kalamaio-templogo.30f76a46.svg";